<!-- eslint-disable vue/no-side-effects-in-computed-properties -->
<template>
  <Transition name="progress">
    <progress
      v-if="isVisibleProgress"
      :value="progressVal"
      max="100"
      class="progress"
    />
  </Transition>
  <!--
    Полоса о состоянии связи жила здесь и переехала в тосты. Показывалась она
    только на смену флага и пряталась через 5 секунд: связь пропадала второй
    раз — не показывалось уже ничего, а прочесть за 5 секунд успевали не все.
    Разбор — docs/toast-notifications.md.
  -->
</template>
<script>
export default {
  name: 'progress-bar',
  data() {
    return {
      visibleProgress: false,
      timeOutID: null,
    };
  },
  watch: {
    connectionStatus() {
      this.visibleProgress = false;
    },
    progressVal(newVal) {
      if (newVal === 0) this.visibleProgress = false;
      if (newVal > 0 && newVal < 99 && this.connectionStatus) this.visibleProgress = true;
      if (newVal >= 99) this.hiddenProgress();
    },
  },
  computed: {
    connectionStatus() {
      return this.$store.getters.isConnected;
    },
    progressVal() {
      return this.$store.getters.isProgressVal;
    },
    isVisibleProgress() {
      return this.visibleProgress;
    },
  },
  mounted() {
    this.$store.commit('setProgressVal', 0);
  },
  beforeUnmount() {
    clearTimeout(this.timeOutID);
  },
  methods: {
    hiddenProgress() {
      clearTimeout(this.timeOutID);
      this.timeOutID = setTimeout(() => {
        this.visibleProgress = false;
      }, 1000);
      // } else {
      //   this.visibleProgress = true;
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.progress {
  display: block;
  box-sizing: border-box;
  // border: solid $b #242b35;
  width: 100%;
  height: 5px;
  opacity: 1;
  border-radius: 1px;
  background: $color-primary;
  // background: #F2F6FD;
  transition: opacity .1s linear;

  &.progress-enter-from,
  &.progress-leave-to {
    opacity: 0;
  }
  &.progress-enter-to,
  &.progress-leave-from {
    opacity: 1;
  }

  &::-webkit-progress-bar { background: transparent }

  &::-webkit-progress-value {
    transition: width .5s ease-in-out;
    border-radius: 1px;
    box-shadow: inset 0 .05em .05em rgba(#fff, .35);
    background: linear-gradient(
      90deg,
      $color-accent 0%,
      $color-accent-light 50%,
      $color-accent 100%,
    );
   }
  &::-moz-progress-bar {
    transition: width .5s ease-in-out;
    border-radius: 1px;
    box-shadow: inset 0 .05em .05em rgba(#fff, .35);
    background: linear-gradient(
      90deg,
      $color-accent 0%,
      $color-accent-light 50%,
      $color-accent 100%,
    );
   }
}
</style>
